import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { TaskNotification } from "../models";
import { config } from "../../shared/config";
import { BaseHttpService } from "../../core/services/base-http.service";
import { StorageService } from "../../core/storage/storage.service";

@Injectable({
  providedIn: "root",
})
export class TaskNotificationsHttpService extends BaseHttpService {
  private readonly apiEndpoint = "Tasks";

  constructor(
    protected readonly http: HttpClient,
    protected readonly storageService: StorageService,
  ) {
    super(http, storageService);
  }

  public getTasks(): Observable<TaskNotification[]> {
    return this.http
      .get(config.generateApiUrl(this.apiEndpoint, null, null, 2.2))
      .pipe(
        map((request) => {
          return request["data"] as TaskNotification[];
        })
      );
  }

  public getTaskById(
    taskId: TaskNotification["taskId"]
  ): Observable<TaskNotification> {
    return this.http
      .get(
        config.generateApiUrl(`${this.apiEndpoint}/${taskId}`, null, null, 2.2)
      )
      .pipe(
        map((request) => {
          return request["data"] as TaskNotification;
        })
      );
  }

  public takeTask(
    taskId: TaskNotification["taskId"]
  ): Observable<TaskNotification> {
    return this.http
      .put(
        config.generateApiUrl(
          `${this.apiEndpoint}/${taskId}/take`,
          null,
          null,
          2.2
        ),
        null
      )
      .pipe(
        map((request) => {
          return request["data"] as TaskNotification;
        })
      );
  }

  public completeTask(
    taskId: TaskNotification["taskId"],
    taskMetadata: { note: string }
  ): Observable<any> {
    return this.http.put(
      config.generateApiUrl(
        `${this.apiEndpoint}/${taskId}/complete`,
        null,
        null,
        2.2
      ),
      taskMetadata
    );
  }

  public addTaskNotification(
    taskIds: TaskNotification["taskId"][],
    taskInfo: any
  ): Observable<any> {
    return this.http
      .post(
        config.generateApiUrl(
          `${this.apiEndpoint}/notifications/${taskIds.join(",")}`,
          null,
          null,
          2.2
        ),
        taskInfo
      )
      .pipe(
        map((request) => {
          return request["data"];
        })
      );
  }

  public updateTaskNotification(
    taskIds: TaskNotification["taskId"][],
    taskInfo: any
  ): Observable<any> {
    return this.http
      .put(
        config.generateApiUrl(
          `${this.apiEndpoint}/notifications/update/${taskIds.join(",")}`,
          null,
          null,
          2.2
        ),
        taskInfo
      )
      .pipe(
        map((request) => {
          return request["data"];
        })
      );
  }
}
